<template>
	<VerticalLayout>
		<span v-if="showLabel">{{ $t(labelKey) }}</span>
		<Select
			class="width-100"
			v-model:value="subNetworkSelectedId"
			:options="subNetworkOptions"
			@change="onChange"
		/>
	</VerticalLayout>
</template>

<script>
import { Select } from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout';

import { useSubnetworkOptions } from '@/components/common/useSubnetworkOptions';

export default {
	components: { VerticalLayout, Select },
	props: {
		onChange: {
			type: Function,
			required: false,
			default: () => {},
		},
		labelKey: {
			type: String,
			default: 'controls.subNetworkFilter.label',
		},
		showLabel: {
			type: Boolean,
			default: true,
		},
	},
	setup(props, { expose }) {
		const { subNetworkOptions, subNetworkSelectedId } = useSubnetworkOptions();
		expose({
			selectedId: subNetworkSelectedId,
			options: subNetworkOptions,
		});
		return {
			subNetworkSelectedId,
			subNetworkOptions,
		};
	},
}
</script>
